import { calendarDate, daysBetween, daysLeft, todayIn, viewerIsElsewhere, zoneName } from '../dates';

/**
 * A notice's due date, said the same way on every screen: what has to happen
 * by when, how many days that leaves, the earlier day to aim for, and — when
 * the date is a Sunday, Saturday or holiday — the last day the post office is
 * usually open. A notice the law counts when it arrives (`mailBy`) must arrive
 * by its due date, so it gives the earlier day to mail it instead. Days count from today where the job is, and say so when the
 * viewer keeps another time.
 */
export type NoticeDates = { dueDate: string; target?: string | null; timeZone: string; postOfficeClosed?: string | null; lastOpenDay?: string | null; mailBy?: string | null };

/** "That's a Sunday, when post offices are usually closed." */
function closedDay(closed: string) {
  return closed === 'Saturday' ? 'That’s a Saturday, when many post offices close early or don’t open.'
    : closed === 'Sunday' ? 'That’s a Sunday, when post offices are usually closed.'
    : `That’s ${closed}, when post offices are closed.`;
}

export function NoticeDueDate({ dueDate, target, timeZone, postOfficeClosed, lastOpenDay, mailBy, served = false, now }: NoticeDates & { served?: boolean; now?: Date }) {
  const today = todayIn(timeZone, now);
  const late = daysBetween(today, dueDate) < 0;
  return <div className="due-date">
    <p className="due-date-main">{mailBy ? 'Must arrive by' : 'Must go out by'} <strong>{calendarDate(dueDate, 'full')}</strong>
      {!served && <b className={late ? 'due-date-left overdue' : 'due-date-left'}> ({daysLeft(dueDate, today)})</b>}</p>
    {!served && target && target.slice(0, 10) < dueDate.slice(0, 10) && daysBetween(today, target) >= 0
      && !mailBy && <p className="due-date-note">Aim for {calendarDate(target, 'full')}; that leaves time to fix a problem before the deadline.</p>}
    {!served && mailBy && <p className="due-date-note">The law counts this notice when it arrives. If you are mailing it yourself, mail it by {calendarDate(mailBy, 'full')}.</p>}
    {!served && postOfficeClosed && lastOpenDay && <p className="due-date-note">{closedDay(postOfficeClosed)} If you are mailing it yourself, plan to mail it by {calendarDate(lastOpenDay, 'full')}.</p>}
    {!served && viewerIsElsewhere(timeZone, now) && <p className="due-date-note due-date-zone">Days are counted in {zoneName(timeZone, now)}, where the job is.</p>}
  </div>;
}
